/* eslint-disable react-hooks/exhaustive-deps */
import { AddCircle, FileUploadOutlined, Clear, Delete, Edit, Search } from "@mui/icons-material";
import { Box, Button, Card, CardContent, Grid, Tooltip } from "@mui/material";
import { GridActionsCellItem, GridRowId, GridRowModel, GridSortModel, GridSortDirection } from "@mui/x-data-grid";
import { useEffect, useMemo, useState } from "react";
import AutoComplete from "../../../components/hookForms/autoComplete";
import { Container } from "../../../theme/globalStyles";
//componenet
import DataTable from "../../../components/dataTable";
import DialogConfirm from "../../../components/confirmationDialog";
import DialogEdit from "./modal/dialogEdit";
import DialogNew from "./modal/dialogNew";
import DialogList from "./modal/dialogList";
import DialogUpload from "./modal/dialogUpload";
import IGenericResult from "../../../interfaces/IGenericResult";
import IGenericMotivoResult from "../../../interfaces/IGenericMotivoResult";
import DatePickerMui from "../../../components/hookForms/datePicker";
import InputNumber from "../../../components/hookForms/inputNumber";
import InputText from "../../../components/hookForms/textField";
import messages from "../../../utils/messages";
import { format } from "date-fns";
import serviceConcessionaria from "../../../services/serviceConcessionaria";
import serviceMotivoMovimentacaoInstalacao from "../../../services/serviceMotivoMovimentacaoInstalacao";
import serviceRebalanceMovimentacaoInstalacao from "../../../services/serviceRebalanceMovimentacaoInstalacao";
import serviceUsina from "../../../services/serviceUsina";
import { toast } from "react-toastify";
import { useAuth } from "../../../context/global";
import { useForm } from "react-hook-form";

const MovimentacaoUcs = (props: any) => {
    const { setTitlePage } = useAuth();

    useEffect(() => {
        setTitlePage("Rebalance - Movimentação Ucs");
    }, [setTitlePage]);

    const [rowCount, setRowCount] = useState(0);
    const [pageSize, setPageSize] = useState(100);
    const [data, setData] = useState<any[]>([]);
    const [filters, setFilters] = useState(null);
    const [page, setPage] = useState(0);
    const [isLoading, setLoading] = useState(false);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [edit, setEdit] = useState(false);
    const [motivoDataOptions, setMotivoDataOptions] = useState<IGenericMotivoResult[]>([]);
    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);
    const [usinaDataOptions, setUsinaDataOptions] = useState<IGenericResult[]>([]);
    const [exclusionState, setExclusionState] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [uploadModal, setUploadModal] = useState(false);
    const [openNew, setOpenNew] = useState(false);
    const [openModalList, setOpenModalList] = useState(false);
    const [listErros, setListErros] = useState<string[]>([]);
    const { handleGetDataUser } = useAuth();

    const [sortModel, setSortModel] = useState<GridSortModel>([
        {
          field: "",
          sort: "" as GridSortDirection
        }
      ]);

    const user = handleGetDataUser();

    const isMasterOrAdmin = user.perfil === "Master" || user.perfil === "Admin";

    const [editState, setEditState] = useState({
        open: false,
        id: "",
        cicloFaturamento: "",
        nomeConcessionaria: "",
        tipoDocumentoCliente: "",
        numeroDocumentoCliente: "",
        nomeCliente: "",
        numeroInstalacao: "",
        cotaAtual: "",
        cotaAlterada: "",
        motivo: "",
        status: "",
        observacao: "",
        concessionariaID: "",
        rebalanceMotivoMovimentacaoInstalacaoID: "",
        rebalanceCicloMovimentacaoInstalacaoID: "",
        rebalanceMovimentacaoInstalacaoID: "",
        usinaID: "",
        tipoCiclo: "",
        dataHoraUltimaAtualizacao: "",
    });

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            concessionariaID: "",
            cicloFaturamento: null,
            nomeConcessionaria: "",
            tipoDocumentoCliente: "",
            numeroDocumentoCliente: "",
            nomeCliente: "",
            numeroInstalacao: "",
            cotaAtual: "",
            cotaAlterada: "",
            rebalanceMotivoMovimentacaoInstalacaoID: "",
            status: "",
            observacao: "",
            usinaID: "",
        },
    });

    const actionColumns = useMemo(
        () => [
            {
                headerName: "Operações",
                field: "operations",
                type: "actions",
                width: 150,
                hide: false,
                getActions: (params: { id: GridRowId; row: GridRowModel }) => [
                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Editar">
                                <Edit />
                            </Tooltip>
                        }
                        label="Editar"
                        onClick={() => {
                            setEditState({
                                open: true,
                                id: params.id.toString(),
                                rebalanceMovimentacaoInstalacaoID: params.row.rebalanceMovimentacaoInstalacaoID,
                                rebalanceMotivoMovimentacaoInstalacaoID:
                                    params.row.rebalanceMotivoMovimentacaoInstalacaoID,
                                rebalanceCicloMovimentacaoInstalacaoID:
                                    params.row.rebalanceCicloMovimentacaoInstalacaoID,
                                numeroInstalacao: params.row.numeroInstalacao,
                                status: params.row.status,
                                concessionariaID: params.row.concessionariaID,
                                usinaID: params.row.usinaID,
                                tipoDocumentoCliente: params.row.tipoDocumentoCliente === "F" ? "CPF" : "CNPJ",
                                numeroDocumentoCliente: params.row.numeroDocumentoCliente,
                                nomeCliente: params.row.nomeCliente,
                                cotaAtual: params.row.cotaAtual,
                                cotaAlterada: params.row.cotaAlterada,
                                observacao: params.row.observacao,
                                cicloFaturamento: params.row.cicloFaturamento,
                                nomeConcessionaria: params.row.nomeConcessionaria,
                                motivo: params.row.motivo,
                                tipoCiclo: params.row.tipoCiclo,
                                dataHoraUltimaAtualizacao: params.row.dataHoraUltimaAtualizacao,
                            });
                        }}
                        disabled={params.row.ativo === "N" || (params.row.status !== "Aberto" && !isMasterOrAdmin)}
                    />,

                    <GridActionsCellItem
                        icon={
                            <Tooltip title="Inativar">
                                <Delete />
                            </Tooltip>
                        }
                        label="Excluir"
                        onClick={() => {
                            setExclusionState({
                                rebalanceMovimentacaoInstalacaoID: params.row.rebalanceMovimentacaoInstalacaoID,
                            });
                            setShowModal(true);
                        }}
                        disabled={params.row.ativo === "N" || (params.row.status !== "Aberto" && !isMasterOrAdmin)}
                    />,
                ],
            },
        ],
        []
    );

    const columns = useMemo(
        () => [
            {
                headerName: "Ciclo",
                field: "cicloFaturamento",
                type: "string",
                width: 80,
            },
            {
                headerName: "Concessionária",
                field: "nomeConcessionaria",
                type: "string",
                width: 200,
            },
            {
                headerName: "Tipo doc.",
                field: "tipoDocumentoCliente",
                type: "string",
                width: 140,
                valueFormatter: (item: any) => {
                    return item.value === "F" ? "CPF" : item.value === "J" ? "CNPJ" : "";
                },
            },
            {
                headerName: "Instalação",
                field: "numeroInstalacao",
                type: "string",
                width: 180,
                
            },
            {
                headerName: "Nome cliente",
                field: "nomeCliente",
                type: "string",
                width: 150,
            },
            {
                headerName: "Documento",
                field: "numeroDocumentoCliente",
                type: "string",
                width: 150,
            },
            {
                headerName: "Cota atual",
                field: "cotaAtual",
                type: "number",
                width: 120,

            },
            {
                headerName: "Cota alterada",
                field: "cotaAlterada",
                type: "number",
                width: 120,

            },
            {
                headerName: "Motivo",
                field: "motivo",
                type: "string",
                width: 200,
            },
            {
                headerName: "Observação",
                field: "observacao",
                type: "string",
                width: 200,
            },
            {
                headerName: "Data fim",
                field: "cicloFim",
                type: "string",
                width: 120,
            },
            {
                headerName: "Ativo",
                field: "ativo",
                type: "string",
                width: 90,
                valueFormatter: (item: any) => {
                    return item.value === "N" ? "Não" : "Sim";
                },
            },
            {
                headerName: "Status",
                field: "status",
                type: "string",
                width: 150,
            },
            ...actionColumns,
        ],
        [actionColumns]
    );

    useEffect(() => {
        setConcessionariaData();
    }, []);

    const setConcessionariaData = async () => {
        serviceConcessionaria
            .getConcessionarias()
            .then((result) => {
                setConcessionariaDataOptions(result?.data);
            })
            .catch(() => {
                setConcessionariaDataOptions([]);
            });
    };

    useEffect(() => {
        setUsinaData();
    }, []);

    const setUsinaData = async () => {
        serviceUsina
            .getUsinas()
            .then((result) => {
                setUsinaDataOptions(result?.data);
            })
            .catch(() => {
                setUsinaDataOptions([]);
            });
    };

    useEffect(() => {
        setMotivoData();
    }, []);

    const setMotivoData = async () => {
        serviceMotivoMovimentacaoInstalacao
            .getMotivos()
            .then((result) => {
                setMotivoDataOptions(result?.data);
            })
            .catch(() => {
                setMotivoDataOptions([]);
            });
    };

    const tipoDocumentoOptions = [
        { label: "CPF", value: "CPF" },
        { label: "CNPJ", value: "CNPJ" },
    ];

    const statusOptions = [
        { label: "Aberto", value: "Aberto" },
        { label: "Em processamento", value: "Em processamento" },
        { label: "Processado", value: "Processado" },
    ];

    const getAllWithFilters = async (filters: any) => {
        setData([]);
        setLoading(true);

        serviceRebalanceMovimentacaoInstalacao
            .getWithFilter({ ...filters, take: pageSize, currentPage: page + 1, 
                sortExpression: sortModel[0]?.field ?? "", sortDirection: sortModel[0]?.sort ?? ""})
            .then((result) => {
                setData(result?.data.content);
                setRowCount(result?.data.numberOfElements);
            })
            .catch((err) => {
                toast.error(messages.getWithFilterError, err);
                setData([]);
                setRowCount(0);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const onClear = () => {
        reset();
        setFilters(null);
        getAllWithFilters(null);
    };

    const onSubmit = (values: any) => {
        const newFilters = {
            ...values,
            tipoDocumentoCliente:
                values.tipoDocumentoCliente === "CPF" ? "F" : values.tipoDocumentoCliente === "CNPJ" ? "J" : "",
            status:
                values.status === "Aberto"
                    ? "A"
                    : values.status === "Processado"
                    ? "P"
                    : values.status === "Em processamento"
                    ? "E"
                    : "",
            cicloFaturamento: values.cicloFaturamento ? format(values.cicloFaturamento, "MM/yyyy") : "",
        };

        setFilters(newFilters);
        getAllWithFilters(newFilters);
    };

    useEffect(() => {
        if (props && props.location && props.location.state) {
            reset(props.location.state);
            setFilters(props.location.state);
            getAllWithFilters(props.location.state);
        }
    }, [props]);

    useEffect(
        () => {
            getAllWithFilters(filters);
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [page, pageSize, sortModel]
    );

    const handleInativar = async () => {
        serviceRebalanceMovimentacaoInstalacao
            .inativar(exclusionState)
            .then((result) => {
                if (result) {
                    toast.success(messages.deleteSucess);
                }
            })
            .catch((err) => {
                toast.error(messages.deleteError, err);
            })
            .finally(() => {
                setExclusionState({});
                getAllWithFilters(filters);
            });
    };

    const onSuccessAction = () => {
        getAllWithFilters(filters);
    };

    return (
        <Container>
            <Card>
                <CardContent>
                    <Box sx={{ mb: 2 }}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <Grid container spacing={2} rowSpacing={-2} display="flex" alignItems="center">
                                <Grid item md={2}>
                                        <DatePickerMui
                                            name="cicloFaturamento"
                                            label="Ciclo"
                                            format="MM/yyyy"
                                            view={["month", "year"]}
                                            control={control}
                                            error={errors}
                                        />
                                </Grid>

                                <Grid item md={2}>
                                    <AutoComplete
                                        name="concessionariaID"
                                        label="Concessionária"
                                        control={control}
                                        error={errors}
                                        options={concessionariaDataOptions}
                                    />
                                </Grid>

                                <Grid item md={2}>
                                    <AutoComplete
                                        name="tipoDocumentoCliente"
                                        label="Tipo de documento"
                                        control={control}
                                        error={errors}
                                        options={tipoDocumentoOptions}
                                    />
                                </Grid>

                                <Grid item md={2}>
                                    <InputNumber
                                        name="numeroInstalacao"
                                        label="Instalação"
                                        control={control}
                                        error={errors}
                                        decimalScale={0}
                                        noThousandSeparator
                                        maxLength={15}
                                    />
                                </Grid>

                                <Grid item md={2}>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        color="warning"
                                        style={{ margin: "16px 0px 8px 0px" }}
                                        startIcon={<Search />}
                                        type="submit"
                                        disabled={isLoading}
                                        disableElevation
                                    >
                                        Pesquisar
                                    </Button>
                                </Grid>

                                <Grid item md={2}>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        style={{ margin: "16px 0px 8px 0px" }}
                                        startIcon={<AddCircle />}
                                        onClick={() => setOpenNew(true)}
                                        disableElevation
                                    >
                                        Novo
                                    </Button>
                                </Grid>

                                <Grid item md={2}>
                                    <AutoComplete
                                        name="usinaID"
                                        label="Usina"
                                        options={usinaDataOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>

                                <Grid item md={2}>
                                    <InputText
                                        name="nomeCliente"
                                        label="Nome cliente"
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>

                                <Grid item md={2}>
                                    <AutoComplete
                                        name="rebalanceMotivoMovimentacaoInstalacaoID"
                                        label="Motivo"
                                        options={motivoDataOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>

                                <Grid item md={2}>
                                    <AutoComplete
                                        name="status"
                                        label="Status"
                                        options={statusOptions}
                                        control={control}
                                        error={errors}
                                    />
                                </Grid>

                                <Grid item md={2} display="flex" justifyContent="flex-start">
                                    <Button
                                        style={{ margin: "16px 0px 8px 0px" }}
                                        variant="outlined"
                                        color="warning"
                                        startIcon={<Clear />}
                                        onClick={() => onClear()}
                                        disableElevation
                                        fullWidth
                                        size="medium"
                                    >
                                        Limpar
                                    </Button>
                                </Grid>

                                <Grid item md={2}>
                                    <Button
                                        variant="contained"
                                        fullWidth
                                        style={{ margin: "16px 0px 8px 0px" }}
                                        startIcon={<FileUploadOutlined />}
                                        onClick={() => setUploadModal(true)}
                                        disableElevation
                                    >
                                        Carregar
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Box>

                    <Box sx={{ height: 450 }}>
                        <DataTable
                            columns={columns}
                            rows={data}
                            rowId={(row: GridRowModel) => row.rebalanceMovimentacaoInstalacaoID}
                            rowCount={rowCount}
                            isLoading={isLoading}
                            onPageChange={(currentPage: number) => setPage(currentPage)}
                            onPageSizeChange={(currentPageSize: number) => setPageSize(currentPageSize)}
                            pageSize={pageSize}
                            onSortModelChange={(model: GridSortModel) => setSortModel(model)}
                        />
                    </Box>

                    <DialogEdit
                        open={editState.open}
                        onSuccess={() => onSuccessAction()}
                        data={{
                            open: editState.open,
                            id: editState.id,
                            cicloFaturamento: editState.cicloFaturamento,
                            nomeConcessionaria: editState.nomeConcessionaria,
                            tipoDocumentoCliente: editState.tipoDocumentoCliente,
                            numeroDocumentoCliente: editState.numeroDocumentoCliente,
                            nomeCliente: editState.nomeCliente,
                            numeroInstalacao: editState.numeroInstalacao,
                            cotaAtual: editState.cotaAtual,
                            cotaAlterada: editState.cotaAlterada,
                            motivo: editState.motivo,
                            status: editState.status,
                            observacao: editState.observacao,
                            concessionariaID: editState.concessionariaID,
                            rebalanceMotivoMovimentacaoInstalacaoID: editState.rebalanceMotivoMovimentacaoInstalacaoID,
                            rebalanceCicloMovimentacaoInstalacaoID: editState.rebalanceCicloMovimentacaoInstalacaoID,
                            rebalanceMovimentacaoInstalacaoID: editState.rebalanceMovimentacaoInstalacaoID,
                            usinaID: editState.usinaID,
                            tipoCiclo: editState.tipoCiclo,
                            dataHoraUltimaAtualizacao: editState.dataHoraUltimaAtualizacao,
                        }}
                        onClose={() => {
                            setEditState({
                                open: false,
                                id: "",
                                cicloFaturamento: "",
                                nomeConcessionaria: "",
                                tipoDocumentoCliente: "",
                                numeroDocumentoCliente: "",
                                nomeCliente: "",
                                numeroInstalacao: "",
                                cotaAtual: "",
                                cotaAlterada: "",
                                motivo: "",
                                status: "",
                                observacao: "",
                                concessionariaID: "",
                                rebalanceMotivoMovimentacaoInstalacaoID: "",
                                rebalanceCicloMovimentacaoInstalacaoID: "",
                                rebalanceMovimentacaoInstalacaoID: "",
                                usinaID: "",
                                tipoCiclo: "",
                                dataHoraUltimaAtualizacao: "",
                            });
                        }}
                    />

                    <DialogNew open={openNew} onClose={() => setOpenNew(false)} onSuccess={() => onSuccessAction()} />

                    <DialogUpload
                        open={uploadModal}
                        onClose={() => setUploadModal(false)}
                        onSuccess={() => onSuccessAction()}
                        returnDate={(item) => {
                            setListErros(item);
                            setOpenModalList(true);
                        }}
                    />

                    <DialogConfirm
                        open={showModal}
                        title={"Inativar"}
                        message={messages.inactiveConfirmation}
                        cancelButtonText={"Não"}
                        confirmButtonText={"Sim"}
                        onClose={() => setShowModal(false)}
                        onCancel={() => setShowModal(false)}
                        onConfirm={() => {
                            setShowModal(false);
                            handleInativar();
                        }}
                    />

                    {openModalList && <DialogList data={listErros} onClose={() => setOpenModalList(false)} />}
                </CardContent>
            </Card>
        </Container>
    );
};

export default MovimentacaoUcs;
